<mat-card class="company-header">
  <div class="company-card">
    <div class="company-data" *ngIf="company">
      <div class="company-name">
        {{ company.getCorporateName() }}
      </div>
      <div class="company-details">
        <span class="company-cnpj"> CNPJ: {{ company.getFiscalNumber() | companyFederalNumber }} </span>
        <span class="company-lives">Colaboradores: {{ company.getCompanyInfo().getEmployeeCount() }} </span>
      </div>
    </div>
    <div class="company-buttons">
      <button *ngIf="isSummaryView()" class="summary-btn" mat-flat-button matTooltip="Voltar ao Resumo de Vendas" (click)="backToSummary()">
        <mat-icon aria-hidden="false">arrow_back</mat-icon>
        <span>Voltar ao Resumo</span>
      </button>
      <button class="change-btn" mat-flat-button matTooltip="Alterar Empresa" (click)="changeCompany()">
        <mat-icon aria-hidden="false">corporate_fare</mat-icon>
        <span>Alterar Empresa</span>
      </button>
    </div>
  </div>
</mat-card>
<mat-card class="search-box">
  <div class="filters-components">
    <form [formGroup]="rootForm" class="filter-form">
      <div fxLayout="column" fxLayoutAlign="center start">
        <span class="title">Tipo de Beneficiário*</span>
        <select class="select-field" required formControlName="type" fxFlex>
          <option [value]="0">Todos</option>
          <option [value]="1">Titular</option>
          <option [value]="2">Dependente</option>
        </select>
      </div>
      <div fxLayout="column" fxLayoutAlign="center start">
        <span class="title">Tipo de Pesquisa*</span>
        <select class="select-field" required formControlName="searchType" fxFlex>
          <option [value]="1">CPF</option>
          <option [value]="2">NOME</option>
          <option [value]="3">Nº DO CARTÃO</option>
        </select>
      </div>
      <div fxLayout="column" fxLayoutAlign="center start">
        <span class="title">{{
          rootForm.controls.searchType.value == 1 ? "Pesquisar CPF" : rootForm.controls.searchType.value == 2 ? "Pesquisar Nome" : "Pesquisar Número do Cartão"
        }}</span>
        <input
          *ngIf="rootForm.controls.searchType.value == 1"
          class="input-field"
          required
          (keypress)="onPressSearch($event)"
          formControlName="search"
          placeholder="123.456.789-00"
          type="text"
          [textMask]="{
            mask: socialNumberMask,
            guide: false,
            keepCharPositions: true
          }" fxFlex />
        <input
          *ngIf="rootForm.controls.searchType.value == 2"
          class="input-field"
          required
          (keypress)="onPressSearch($event)"
          [formControl]="rootForm.controls.search"
          placeholder="NOME DO BENEFICIÁRIO" fxFlex />
        <input
          *ngIf="rootForm.controls.searchType.value == 3"
          class="input-field"
          required
          (keypress)="onPressSearch($event)"
          [formControl]="rootForm.controls.search"
          placeholder="NÚMERO DO CARTÃO"
          type="text"
          [textMask]="{
            mask: cardNumberMask,
            guide: false,
            keepCharPositions: true
          }" fxFlex />
      </div>
    </form>
    <div class="filter-button">
      <button mat-flat-button class="filter-btn" (click)="search()" matTooltip="Pesquisar">
        <mat-icon aria-hidden="false">search</mat-icon>
        <span>Pesquisar</span>
      </button>
    </div>
  </div>
</mat-card>
